import { useState } from 'react';
import customHeaders, { getSpace } from '../../common/headers';
import { useEffect } from 'react';
import useGeneralStore from '../../store/general';
import check_green from './img/bx-check.svg';
import plus_circle from './img/bx-plus-circle.svg';
import { ButtonBasic, InputDinamycPlaceholder, NoDataContent } from '@lk-gtcom/ecomlab-components';
import { ButtonWithIcon } from '../Buttons/ButtonWithIcon/ButtonWithIcon';
import { SubtaskItem } from './SubTask/SubTask';
import "./CheckList.scss"
import { TitlePage } from '../TitlePage/TitlePage';
import { MoonLoader } from 'react-spinners';

const CheckList = ({
    authorEmail,
    idTable,
    style,
    title,
    loading,
    update
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    // Подзадачник
    const email = localStorage.getItem('email');
    const [isNewSubtask, setIsNewSubtask] = useState(false);
    const [nameSubTask, setNameSubTask] = useState('');
    const [taskList, setTasklist] = useState('')

    useEffect(() => {
        fetchGetCustomTableDataDict();
    }, [idTable]);


    // получение
    const fetchGetCustomTableDataDict = (
        abortController = new AbortController()
    ) => {
        if (idTable) {
            let url = `https://apps1.ecomru.ru:4434/api/custom_table/get_custom_table_data_dict`

            const body = JSON.stringify({
                table_uid: idTable,
            });

            fetch(url, {
                body,
                method: 'POST',
                headers,
                signal: abortController.signal,
            })
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error('bad events response');
                    }
                })
                .then((json) => {
                    setTasklist(json);
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    };

    // Добавление
    const fetchAddRow = (task_name, abortController = new AbortController()) => {
        if (!idTable) return;

        let url = `https://apps1.ecomru.ru:4434/api/custom_table/add_row_with_name`

        const body = JSON.stringify({
            table_uid: idTable,
            value: task_name,
        });

        fetch(url, {
            body,
            method: 'POST',
            headers,
            signal: abortController.signal,
        })
            .then((res) => {
                if (res.ok) {
                    setTimeout(() => fetchGetCustomTableDataDict(), 1000)
                    return res.json();
                } else {
                    throw new Error('bad events response');
                }
            })
            .then((json) => { })
            .catch((err) => {
                console.error(err);
            });
    };

    // Редактирование
    const fetchEditRow = (row_id, type, value) => {
        const url = `https://apps1.ecomru.ru:4434/api/custom_table/add_custom_table_data`;

        const body = JSON.stringify({
            table_uid: idTable,
            data: [
                {
                    row_uid: row_id,
                    value: value,
                    field_name: type,
                },
            ],
        });

        fetch(url, { method: 'POST', headers, body })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('bad events response');
                }
            })
            .then((json) => {
                setTimeout(() => fetchGetCustomTableDataDict(), 1000)
            })
            .catch((err) => console.error(err));
    };

    // Удаление 
    const fetchDeleteRow = (row_id, abortController = new AbortController()) => {
        if (!idTable) return;

        let url = `https://apps1.ecomru.ru:4434/api/custom_table/delete_custom_table_row`;

        const body = JSON.stringify({
            table_uid: idTable,
            row_uid: row_id,
        });

        fetch(url, {
            body,
            method: 'DELETE',
            headers,
            signal: abortController.signal,
        })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('bad events response');
                }
            })
            .then((json) => {
                setTimeout(() => fetchGetCustomTableDataDict(), 1000)
            })
            .catch((err) => {
                console.error(err);
            });
    };


    return (
        <>
            {title && <TitlePage
                title={title}
            />}

            <div className="subtasks-list"
                style={style}
            >
                <div className="subtasks-list__header">
                    {!isNewSubtask ?
                        <>
                            {authorEmail === email &&
                                <ButtonBasic
                                    grey
                                    width="100%"
                                    icon={plus_circle}
                                    text={'Новая задача'}
                                    onClick={(e) => setIsNewSubtask(true)}
                                    loading={loading}
                                />
                            }
                        </>
                        : (
                            <div className="subtasks-list__input-box">
                                <InputDinamycPlaceholder
                                    onChange={(e) => setNameSubTask(e)}
                                    placeholder=""
                                    size="s"
                                />

                                <ButtonWithIcon
                                    grey
                                    size='m'
                                    icon={check_green}
                                    onClick={(e) => {
                                        setIsNewSubtask(false);
                                        fetchAddRow(nameSubTask);
                                        setNameSubTask('');
                                    }}
                                />
                            </div>
                        )}
                </div>
                {taskList.length > 0 ?
                    <div className="subtasks-list__content">
                        {taskList.map(({ row_id, checkbox, title, date }) => (
                            <SubtaskItem
                                key={title}
                                date={date}
                                title={title}
                                row_id={row_id}
                                checkbox={checkbox}
                                fetchDeleteRow={fetchDeleteRow}
                                fetchEditRow={fetchEditRow}
                                authorEmail={authorEmail}
                                email={email}
                            />
                        ))}
                    </div>
                    :
                    <NoDataContent
                        height='100%'
                        title={'Нет данных по заданным параметрам'}
                        border={false}
                    />
                }
            </div>
        </>
    )
}

export { CheckList }